// Vendors
import { Container, Sprite } from "pixi.js";
import { gsap, TweenMax } from "gsap";
// Main Instance
import { Main } from "screens/main";
// Levels
import { LevelObject } from "shared/levels";
// Event Emmiter
import { EventBus } from "shared/emmiter";
import { ReleaseBlock, ReleaseBg, Block } from "shared/model";
import { isAbsolute } from "path";
import { FillBarService, LanguageService, LoaderService, ShuffleService, SoundService } from "shared/services";
import { DefaultConfig, LevelsConfig, ScoreConfig } from "shared/config";
import { TilesHelper, MapGraphicsHelper } from "shared/helpers";
import { Game } from "screens";
import { v4 as uuidv4 } from 'uuid';

export class BackgroundReleaseMechanic extends Container {

    private tilesContainer: PIXI.Container;
    private helperBloclsContainer: PIXI.Container;
    private animationContainer: PIXI.Container;
    private backgroundSubstate: PIXI.Container;
    private linesSubstate: PIXI.Container;
    private bgImage: ReleaseBg;
    private drag: boolean;
    private score: number;
    private clusters;
    private moves;
    public level;
    private matrix: any;
    private hintTimer;
    private tileHintTimer;
    private booleanMatrix;
    private concatedMatrix;
    private needToOpen: number = 0;
    private tilesOpen: number = 0;
    private isGameEnd: boolean = false;
    private startForSpawn = [];
    private bgCutImage;
    private time = {
        start: null,
        end: null,
        difference: null
    };
    private timer: number = 2000;

    constructor(level) {
        super();
        this.level = level;
        this.init();
    }

    public init(): void {
        this.isGameEnd = false;
        this.interactive = true;

        this.on("pointerdown", this.onMouseDown);
        this.on("pointerup", this.onMouseUp);
        this.on("pointermove", this.onMouseMove);
        // this.on("pointerout", this.onMouseOut);

        this.score = 0;
        this.tilesContainer = new PIXI.Container();
        this.tilesContainer.zIndex = 1000;
        this.helperBloclsContainer = new PIXI.Container();
        this.backgroundSubstate = new PIXI.Container;
        this.linesSubstate = new PIXI.Container;
        this.helperBloclsContainer.name = 'black_substate'
        this.helperBloclsContainer.zIndex = 100;
        this.backgroundSubstate.zIndex = 100;
        this.linesSubstate.zIndex = 200;
        this.animationContainer = new PIXI.Container();
        this.animationContainer.zIndex = 1100;
        this.animationContainer.name = 'animation_container'
        this.matrix = LevelsConfig.levels[this.level.num].array;

        const isAnimCreated = LevelObject.animations.length > 0 ? true : false;

        this.time = {
            start: null,
            end: null,
            difference: null
        };

        for (let i = 0; i < this.matrix.length; i++) {
            if (!isAnimCreated) {
                LevelObject.tiles[i] = [];
            }

            this.startForSpawn[i] = []
            for (let j = 0; j < this.matrix[i].matrix.length; j++) {
                LevelObject.tiles[i][j] = [];

                if (!LevelObject.animations[j] && !isAnimCreated) {
                    LevelObject.animations[j] = [];
                }

                let firstTile;
                for (let d = 0; d < this.matrix[i].matrix[j].length; d++) {
                    const sprite = this.createTile(i, j, d);
                    LevelObject.tiles[i][j].push(sprite);
                    this.tilesContainer.addChild(sprite);
                    const helperBlock = this.createHelperTile(sprite);
                    this.needToOpen += 1;
                    if (sprite.alpha === 0) {
                        helperBlock.isNeedToOpen = false;
                        helperBlock.isRelease = true;
                        helperBlock.alpha = 0;
                        this.needToOpen -= 1;
                    }

                    if (sprite.alpha !== 0 && !firstTile) {
                        firstTile = sprite;
                    }

                    if (!LevelObject.animations[j][d] && !isAnimCreated) {
                        const animation = this.createNewAnimation(sprite.x, sprite.y, sprite);
                        LevelObject.animations[j][d] = animation;
                        this.animationContainer.addChild(animation);
                    }
                }

                if (firstTile) {
                    this.matrix[i].startY = firstTile.y;
                    this.startForSpawn[i][j] = firstTile.y;
                }
            }
        }
        MapGraphicsHelper.addGraphics(this.getConcatedMatrix(), this.helperBloclsContainer, this.linesSubstate, LevelObject.helpersBlocks);
        this.time.start = new Date().getTime();

        this.addChild(this.helperBloclsContainer, this.tilesContainer, this.linesSubstate);
        Main.instance.app.stage.addChild(this.animationContainer)
        this.createBooleanMatrix();
        this.addBackgroundImage();
        this.sortContainerChildren(this);
        this.getAllChains(true, true, true);

        EventBus.emmiter.removeAllListeners();

        EventBus.emmiter.on('game_end', () => {
            this.isGameEnd = true;
        })

        EventBus.emmiter.on('reset_substate', () => {
            const helperBlocks = LevelObject.helpersBlocks;
            for (let i = 0; i < helperBlocks.length; i++) {
                for (let j = 0; j < helperBlocks[i].length; j++) {
                    const block = helperBlocks[i][j];

                    if (block) {
                        block.isRelease = false;
                        block.alpha = 0.98;
                    }
                }
            }
        })

        EventBus.emmiter.on('reset_game', () => {
            this.removeAllListeners();
            this.score = 0;
            this.deleteAll();
            this.init();
        })

    }

    public calcTime(): void {
        const user = JSON.parse(localStorage.getItem('mbny_game_user'));
        const userLevels = user.levels;
        this.time.end = new Date().getTime();
        const start = this.time.start;
        const end = this.time.end;
        const totalSeconds = (end - start) / 1000;
        let difMinutes: any = Math.floor(totalSeconds / 60);
        difMinutes = difMinutes > 9 ? difMinutes : `${difMinutes}`;
        let difSeconds: any = Math.floor(totalSeconds - difMinutes * 60);
        difSeconds = difSeconds > 9 ? difSeconds : `${difSeconds}`;

        const dif = `${difMinutes}${LanguageService.getTranslation('loc_pixi_min')} ${difSeconds}${LanguageService.getTranslation('loc_pixi_sec')}`;

        for (const key in userLevels) {
            if (userLevels.hasOwnProperty(key) && Number.parseInt(key) === Number.parseInt(this.level.num)) {
                const element = userLevels[key];
                element.time = dif;
                // user.levels[key].time = dif;
                user.levels[key].time = Math.round(totalSeconds);
            }
        }

        localStorage.setItem('mbny_game_user', JSON.stringify(user));
    }

    private deleteAll(): void {
        const background = this.getChildByName('test_bg_mechanic');
        this.removeChild(background);
        this.tilesContainer.removeChildren();
        this.helperBloclsContainer.removeChildren();

    }

    private createNewAnimation(x, y, tile) {
        const destructAnimation: PIXI.AnimatedSprite = new PIXI.AnimatedSprite(LoaderService.getSpritesheet('destruct_tile').animations['tile_explosion']);
        destructAnimation.x = x + tile.width / 2;
        destructAnimation.y = y + tile.height / 3;
        destructAnimation.name = 'destruct_anim';
        destructAnimation.alpha = 0;
        destructAnimation.loop = false;
        destructAnimation.animationSpeed = 0.5;
        destructAnimation.onComplete = () => {
            destructAnimation.alpha = 0;
        }
        return destructAnimation;
    }

    // private createHelperBlocks(): void {
    //     const array = this.getConcatedMatrix();

    //     for (let i = 0; i < array.length; i++) {
    //         for (let j = 0; j < array[i].length; j++) {
    //             const el = array[i][j];

    //             if (el !== 0) {
    //                 const helperBlock = this.createHelperTile(el);
    //                 LevelObject.helpersBlocks[j][d].push(helperBlock);
    //                 this.helperBloclsContainer.addChild(helperBlock);
    //             }
    //         }
    //     }
    // }

    private createTile(i, j, d, needToAdd = 0): Block {
        const texture = TilesHelper.getNewTexture(LevelsConfig.levels[this.level.num].drop_chance);
        let sprite: Block;
        sprite = new Block(texture.texture);
        sprite.type = texture.type;
        const coord = this.getCoordinateTile(j, d);
        sprite.width = LevelObject.tileWidth - LevelObject.tilesMargin;
        sprite.height = LevelObject.tileHeight - LevelObject.tilesMargin;
        sprite.x = coord.tileX;
        sprite.y = coord.tileY;
        sprite.mapNum = i;

        if (needToAdd > 0) {
            sprite.row = needToAdd - d - 1;
        } else {
            sprite.row = d;
        }

        sprite.col = j;
        sprite.isDelete = false;
        sprite.id = uuidv4();
        // sprite.stateMachine = new BlockStateMashine(sprite);
        sprite.shift = 0;
        sprite.originScale.x = sprite.scale.x;
        sprite.originScale.y = sprite.scale.y;
        if (needToAdd > 0) {
            if (this.booleanMatrix[sprite.row][sprite.col] === 0) {
                sprite.alpha = 0;
                sprite.isHidden = true;
            }

        } else if (this.matrix[i].matrix[sprite.row][sprite.col] === 0) {
            sprite.alpha = 0;
            sprite.isHidden = true;
        }

        return sprite;
    }

    protected getCoordinateTile(column, row) {
        var tileX = column * LevelObject.tileWidth;
        var tileY = row * LevelObject.tileHeight;
        // var tileX = LevelObject.x + column  * LevelObject.tileWidth;
        // var tileY = LevelObject.y + row * LevelObject.tileHeight;
        return { tileX: tileX, tileY: tileY };
    }

    public callGetAllChaint(): void {
        this.getAllChains(false, true, false, true);
    }

    private async getAllChains(isStart: boolean, isNeedToRemove: boolean, isAuto: boolean, isAfterSwap: boolean = false) {
        clearTimeout(this.hintTimer);
        this.scaleMoves(false);
        await this.clearShifts();

        if (this.isGameEnd) {
            return;
        }

        this.scaleMoves(false);
        this.findClusters()

        if (this.clusters.length > 0 && isNeedToRemove) {
            this.interactive = false;
            this.deleteChains(this.clusters, isStart);

            if (!isStart) {
                this.changeScore(this.clusters.length, isAuto);
            }

            return true;
        } else if (!isNeedToRemove) {
            this.clusters = this.clusters;

            return true;
        }

        if (this.clusters.length === 0 && !isStart) {
            await this.findMoves(isStart);
            await this.checkMoves();

            if (this.moves.length === 0) {
                Game.instance.toggleMixScreen(true);
            } else {
                for (let i = 0; i < this.moves.length; i++) {
                    const tile1 = this.moves[i].tile1;
                    const tile2 = this.moves[i].tile2;

                    if (tile1.type === 0 || tile2.type === 0) {
                        this.moves.splice(i, 1);
                    }
                }
                this.findMoves(false);

                if (this.moves.length === 0) {
                    Game.instance.toggleMixScreen(true);
                    return;
                }

                Game.instance.toggleMixScreen(false);
                clearTimeout(this.hintTimer);
                this.hintTimer = setTimeout(() => {
                    this.scaleMoves(true, 0);
                }, 7000);
            }
        }

        if (this.moves && this.moves.length > 0 && !isAfterSwap) {
            this.interactive = true;
        }

        return false;
    }

    private async clearShifts(): Promise<void> {
        const tiles = LevelObject.tiles;

        new Promise((res, rej) => {
            for (let i = 0; i < tiles.length; i++) {
                for (let j = 0; j < tiles[i].length; j++) {
                    for (let d = 0; d < tiles[i][j].length; d++) {
                        const tile = tiles[i][j][d];

                        tile.shift = 0;

                        if (i === tiles.length - 1 && j === tiles[i].length - 1 && d === tiles[i][j].length - 1) {
                            res(null);
                        }
                    }
                }
            }
        })
    }

    private async checkMoves(): Promise<void> {
        const moves = this.moves;
        const matrix = this.getConcatedMatrix();

        if (!this.moves) {
            return;
        }

        for (let i = 0; i < moves.length; i++) {
            const tile1 = matrix[moves[i].column1][moves[i].row1];
            const tile2 = matrix[moves[i].column2][moves[i].row2];

            if (tile1 === 0 || tile2 === 0) {
                this.moves.splice(i, 1)
            }
        }
    }

    private findClusters(isNeedToRemove: boolean = true) {
        const grid = LevelObject.tiles;
        let result = [];
        let row: number;
        let col: number;
        let array = this.getConcatedMatrix();
        for (row = 0; row < array.length; row++) {
            result = result.concat(this.getHorizontalChains(array, row, isNeedToRemove));
        }

        for (col = 0; col < array.length; col++) {
            result = result.concat(this.getVerticalChains(array, col, isNeedToRemove));
        }

        if (result.length >= 3 && isNeedToRemove) {
            for (let i = 0; i < result.length; i++) {
                result[i].type = -1;
            }
        }

        this.clusters = result;
    }

    private createBooleanMatrix() {
        const array = [];
        for (let i = 0; i < LevelObject.rows; i++) {
            array[i] = [];
            for (let j = LevelObject.columns - 1; j >= 0; j--) {
                const tile = this.getTile(i, j);

                if (tile !== null) {
                    array[i].unshift(1);
                } else {
                    array[i].unshift(0);
                }

            }
        }
        this.booleanMatrix = array;
    }

    private getConcatedMatrix() {
        const array = [];
        for (let i = 0; i < LevelObject.rows; i++) {
            array[i] = [];
            for (let j = LevelObject.columns - 1; j >= 0; j--) {
                const tile = this.getTile(i, j);

                if (tile !== null) {
                    array[i].unshift(tile);
                } else {
                    array[i].unshift(0);
                }

            }
        }
        this.concatedMatrix = array;
        return array;
    }

    private getTile(j, d) {
        const matrixes = LevelObject.tiles;
        let activeTile = null;
        for (let i = 0; i < matrixes.length; i++) {
            const matrix = matrixes[i];
            const tile = matrix[d][j];
            if (tile.alpha !== 0 && tile.type !== 0) {
                activeTile = tile;
                break;
            }
        }

        return activeTile;
    }

    private deleteChains(chains, isStart): void {

        const tiles = LevelObject.tiles;
        for (let i = 0; i < tiles.length; i++) {
            for (let j = 0; j < tiles[i].length; j++) {
                let shift = 0;
                for (let d = tiles[i][j].length - 1; d >= 0; d--) {
                    const tile = LevelObject.tiles[i][j][d];
                    if (tile.type === -1) {
                        shift += 1;
                        // LevelObject.tiles[i][j].splice(d, 1);
                        // this.tiles.removeChild(tile);
                    } else {
                        tiles[i][j][d].shift = shift;
                        tiles[i][j][d].row = tiles[i][j][d].row + shift;
                    }
                }
            }
        }

        this.moveBlocks(isStart);
    }

    private moveBlocks(isStart: boolean): void {
        let needToAnim = [];
        const tiles = LevelObject.tiles;

        for (let i = 0; i < tiles.length; i++) {
            for (let j = 0; j < tiles[i].length; j++) {
                let deletedTiles = 0;
                for (let d = tiles[i][j].length - 1; d >= 0; d--) {
                    const tile = tiles[i][j][d];

                    if (tile && tile.type === -1 && !isStart) {
                        LevelObject.animations[j][d].alpha = 1;
                        LevelObject.animations[j][d].gotoAndPlay(0);
                        LevelObject.tiles[i][j].splice(d, 1);
                        tile.destroy();
                        this.tilesContainer.removeChild(tile);
                        if (LevelObject.helpersBlocks[d][j] && !isStart) {

                            if (!LevelObject.helpersBlocks[d][j].isRelease) {
                                this.tilesOpen += 1;
                            }

                            LevelObject.helpersBlocks[d][j].alpha = 0;
                            LevelObject.helpersBlocks[d][j].isRelease = true;

                        }

                        deletedTiles += 1;
                        continue;
                    }

                    if (tile && tile.shift > 0) {
                        needToAnim.push(tile);
                    }
                }

                if (deletedTiles > 0) {
                    const newTiles = this.createNewTiles(i, j, deletedTiles);
                    needToAnim = needToAnim.concat(newTiles);
                }
            }
        }


        if (isStart) {
            this.mixTiles(true);
            this.getAllChains(true, true, true);
        } else {
            this.animLower(needToAnim);
        }
    }

    private createNewTiles(atrI, j, needToAdd): any[] {
        const array = [];
        let firstTile = LevelObject.tiles[atrI][j][0];
        let firstNotCreated = LevelObject.tiles[atrI][j][0];
        for (let i = 0; i < needToAdd; i++) {
            firstTile = LevelObject.tiles[atrI][j][0];
            let sprite;

            sprite = this.createTile(atrI, j, i, needToAdd);
            sprite.isNew = true;

            if (firstTile) {
                sprite.y = firstTile.y - (sprite.height + LevelObject.tilesMargin);
                sprite.shift = firstTile.shift;
            } else {
                sprite.y = 0 - (sprite.height + LevelObject.tilesMargin);
                sprite.shift = 0;
            }

            if (firstNotCreated && firstNotCreated.shift === 0 && needToAdd === 1) {
                sprite.y = 0 - (sprite.height + LevelObject.tilesMargin);
                sprite.shift = 1;
            }

            if (firstNotCreated && firstNotCreated.shift === 0 && needToAdd > 1) {
                sprite.shift = needToAdd;
                sprite.y = 0 - ((sprite.height + LevelObject.tilesMargin) * (i + 1))
            }

            if (!firstNotCreated) {
                sprite.shift = needToAdd;
                sprite.renderable = true;
            }

            // sprite.shift += emptyNum;
            array.unshift(sprite);
            LevelObject.tiles[atrI][j].unshift(sprite);
            this.tilesContainer.addChild(sprite);
        }

        return array;
    }

    private async animLower(tiles) {
        clearTimeout(this.hintTimer);
        this.scaleMoves(false);
        await new Promise((res, rej) => {
            SoundService.toggleMatch(true, 1);
            for (let i = 0; i < tiles.length; i++) {
                tiles[i].alpha = 0;
                const tileY = tiles[i].y + LevelObject.tileHeight * tiles[i].shift;
                gsap.to(tiles[i], {
                    y: tileY, duration: 0.7,
                    ease: 'bounce',
                    onComplete: () => {
                        tiles[i].y = tileY;
                        tiles[i].shift = 0;
                        if (i === tiles.length - 1) {
                            res(null);
                        }
                    },
                    onUpdate: () => {
                        const map = tiles[i].mapNum;
                        let row = tiles[i].row;
                        const col = tiles[i].col;

                        tiles[i].renderable = true;

                        if (row >= 7) {
                            tiles[i].row = 6;
                            row = 6;
                        }

                        if (row <= -1) {
                            tiles[i].row = 0;
                            row = 0;
                        }

                        const startY = this.startForSpawn[map][col];
                        const array = this.getConcatedMatrix();
                        // if (this.booleanMatrix[row][col] === 0) {
                        //     tiles[i].alpha = 0;
                        //     tiles[i].isHidden = true;
                        // } else {
                        //     if (tiles[i].y >= startY - tiles[i].height) {
                        //         tiles[i].alpha = 1;
                        //         tiles[i].isHidden = false;
                        //     }
                        // }

                        if (tiles[i].y >= startY - tiles[i].height && tiles[i].alpha === 0) {
                            tiles[i].alpha = 1;
                            tiles[i].isHidden = false;
                        }
                    }
                })
            }
        })

        let isBackgroudRelease = false;
        const helperBlocks = LevelObject.helpersBlocks;

        for (let i = 0; i < helperBlocks.length; i++) {
            for (let j = 0; j < helperBlocks[i].length; j++) {
                if (helperBlocks[i][j].isRelease || helperBlocks[i][j] === 0) {
                    isBackgroudRelease = true;
                    continue;
                } else {
                    isBackgroudRelease = false;
                    break
                }
            }

            if (!isBackgroudRelease) {
                break;
            }
        }

        if (!isBackgroudRelease) {
            setTimeout(() => {
                this.getAllChains(false, true, true);
            }, 200)
        } else {
            this.hideAllBlocks();
        }
    }

    private hideAllBlocks(): void {
        this.bgImage.filters = [];
        const tiles = LevelObject.tiles;
        this.linesSubstate.alpha = 0;
        LevelObject.helpersBlocks = [];

        for (let i = 0; i < tiles.length; i++) {
            for (let j = 0; j < tiles[i].length; j++) {
                for (let d = 0; d < tiles[i][j].length; d++) {
                    tiles[i][j][d].alpha = 0
                }
            }
        }
        this.bgCutImage.alpha = 0;
        this.removeChild(this.bgCutImage);
        gsap.to(this.bgImage, { alpha: 1, duration: 0.4, ease: 'none' })
        FillBarService.changeScore(0, this.needToOpen, this.needToOpen, this.level.num, this.timer);
        // setTimeout(() => {
        //     FillBarService.changeBarFill(200, 100);
        // }, 4000)
    }

    protected findMoves(state) {
        const moves = [];
        // Check horizontal swaps
        this.moves = [];
        let clusters;
        let tiles = this.getConcatedMatrix();

        for (let i = 0; i < tiles.length - 1; i++) {
            for (let j = 0; j < tiles[i].length; j++) {
                let isRare = false;
                const isSwap = this.swap(i, j, i + 1, j);
                if (isSwap) {
                    this.findClusters(false);
                    this.swap(i, j, i + 1, j);
                }

                if (this.clusters && this.clusters.length > 0) {
                    const tile = tiles[i][j];
                    // Found a move
                    this.moves.push({
                        column1: i, row1: j,
                        column2: i + 1, row2: j,
                        tile1: tile, tile2: tiles[i + 1][j],
                    });
                }

                if (this.moves.length > 0) {
                    break;
                }
            }

            if (this.moves.length > 0) {
                break;
            }
        }

        for (let i = 0; i < tiles.length; i++) {
            for (let j = 0; j < tiles[i].length - 1; j++) {
                let isRare = false;
                const isSwap = this.swap(i, j, i, j + 1);
                if (isSwap) {
                    this.findClusters(false);
                    this.swap(i, j, i, j + 1);
                }

                if (this.clusters && this.clusters.length > 0) {
                    const tile = tiles[i][j];
                    // Found a move
                    this.moves.push({
                        column1: i, row1: j,
                        column2: i, row2: j + 1,
                        tile1: tile, tile2: tiles[i][j + 1],
                    });

                }

                if (this.moves.length > 0) {
                    break;
                }
            }

            if (this.moves.length > 0) {
                break;
            }
        }

        this.clusters = [];
        if (state) {
            if (this.moves.length === 0) {
                this.mixTiles(true);
            } else {
                clearTimeout(this.hintTimer);
                this.hintTimer = setTimeout(() => {
                    this.scaleMoves(true, 0);
                }, 7000)
            }
        }
        // // Reset moves
        // this.moves = []
        // const tiles = LevelObject.tiles;
        // // Check horizontal swaps

        // let array = this.getConcatedMatrix();

        // new Promise((res, rej) => {
        //     for (let i = 0; i < array.length - 1; i++) {
        //         for (let j = 0; j < array[i].length; j++) {
        //             const isSwap = this.swap(i, j, i + 1, j);
        //             if (isSwap) {
        //                 this.findClusters(false);
        //                 this.swap(i, j, i + 1, j);
        //             }

        //             if (this.clusters.length > 0) {
        //                 const tile = array[i][j];
        //                 // Found a move
        //                 this.moves.push({
        //                     column1: i, row1: j,
        //                     column2: i + 1, row2: j,
        //                     tile1: tile, tile2: array[i + 1][j]
        //                 });
        //             }
        //         }
        //     }

        //     for (let i = 0; i < array.length; i++) {
        //         for (let j = 0; j < array[i].length - 1; j++) {
        //             const isSwap = this.swap(i, j, i, j + 1);
        //             if (isSwap) {
        //                 this.findClusters(false);
        //                 this.swap(i, j, i, j + 1);
        //             }

        //             if (this.clusters.length > 0) {
        //                 const tile = array[i][j];
        //                 // Found a move
        //                 this.moves.push({
        //                     column1: i, row1: j,
        //                     column2: i, row2: j + 1,
        //                     tile1: tile, tile2: array[i][j + 1]
        //                 });
        //             }

        //             if (i === array.length - 1 && j === array[i].length - 2) {
        //                 res();
        //             }
        //         }
        //     }
        // })
        // // Reset clusters
        // this.clusters = [];
        // if (state) {
        //     if (this.moves.length === 0) {
        //         this.mixTiles(true);
        //     } else {
        //         clearTimeout(this.hintTimer);
        //         this.hintTimer = setTimeout(() => {
        //             this.scaleMoves(true, 0);
        //         }, 6000)
        //     }
        // }
    }

    private scaleMoves(state, num?): void {
        const moves = this.moves;
        const duration = 0.8;

        if (state && moves.length > num) {
            const tile1 = moves[num].tile1;
            const tile2 = moves[num].tile2;
            if (tile1 && tile2 && tile1.type !== 0 && tile2.type !== 0) {
                gsap.to(tile1.scale, { x: 0.53, y: 0.53, repeat: 3, yoyo: true, duration: duration })
                gsap.to(tile2.scale, { x: 0.53, y: 0.53, repeat: 3, yoyo: true, duration: duration })
            } else {
                this.moves.splice(num, 1);
            }
            this.tileHintTimer = setTimeout(() => {

                if (num + 1 === moves.length) {
                    num = -1;
                }

                this.scaleMoves(true, num + 1)
            }, (duration * 5.5) * 1250);
        }

        if (!state && moves) {
            clearTimeout(this.hintTimer);
            clearTimeout(this.tileHintTimer);
            for (let i = 0; i < moves.length; i++) {
                if (moves[i].tile1 && !moves[i].tile1._destroyed) {
                    gsap.killTweensOf(moves[i].tile1.scale)
                    moves[i].tile1.scale.set(moves[i].tile1.originScale.x, moves[i].tile1.originScale.y)
                }

                if (moves[i].tile2 && !moves[i].tile2._destroyed) {
                    gsap.killTweensOf(moves[i].tile2.scale)
                    moves[i].tile2.scale.set(moves[i].tile2.originScale.x, moves[i].tile2.originScale.y)
                }
            }
        }
    }

    public mixTiles(state) {
        this.interactive = false;
        const tiles = LevelObject.tiles;
        for (let i = 0; i < tiles.length; i++) {
            for (let j = 0; j < tiles[i].length; j++) {
                for (let d = 0; d < tiles[i][j].length; d++) {
                    if (tiles[i][j][d].type !== 0) {
                        const newTile = TilesHelper.getNewTexture(LevelsConfig.levels[this.level.num].drop_chance);
                        LevelObject.tiles[i][j][d].texture = newTile.texture;
                        LevelObject.tiles[i][j][d].type = newTile.type;
                    }
                }
            }
        }

        this.findClusters();

        if (this.clusters.length > 0) {
            this.mixTiles(state);
        } else {
            this.findMoves(state);
        }
        this.interactive = true;
    };

    protected swap(x1, y1, x2, y2) {
        const array = this.getConcatedMatrix();

        const tile1 = array[x1][y1];
        const tile2 = array[x2][y2];

        if (tile1 === 0 || tile2 === 0) {
            return false;
        }

        let typeSwap = array[x1][y1].type;
        array[x1][y1].type = array[x2][y2].type;
        array[x2][y2].type = typeSwap;
        return true
    }

    private getHorizontalChains(grid, row: number, isNeedToRemove: boolean = true): any[] {
        let result: any[] = [];
        let horizontal: any[];
        let piece;
        let pieceBefore;
        let col: number;
        pieceBefore = grid[0][row];
        horizontal = [];
        horizontal.push(pieceBefore);
        for (col = 1; col < grid.length; col++) {
            piece = grid[col][row];
            if (piece !== 0 && pieceBefore !== 0
                && piece.type === pieceBefore.type
                && piece.alpha !== 0 && pieceBefore.alpha !== 0
                && !piece.isHidden && !pieceBefore.isHidden) {
                horizontal.push(piece);
            } else {
                if (horizontal.length >= 3) {
                    result = result.concat(horizontal);
                }
                horizontal = [];
                horizontal.push(piece);
            }

            pieceBefore = piece;
        }
        if (horizontal.length >= 3) {
            result = result.concat(horizontal);
        }

        return result;
    }

    private getVerticalChains(grid, col: number, isNeedToRemove: boolean = true): any[] {
        let result: any[] = [];
        let vertical: any[];
        let piece;
        let pieceBefore;
        let row: number;

        pieceBefore = grid[col][0];

        vertical = [];
        vertical.push(pieceBefore);

        for (row = 1; row < grid.length; row++) {
            piece = grid[col][row];

            if (piece !== 0 && pieceBefore !== 0
                && piece.type === pieceBefore.type
                && piece.alpha !== 0 && pieceBefore.alpha !== 0
                && !piece.isHidden && !pieceBefore.isHidden) {
                vertical.push(piece);
            } else {
                if (vertical.length >= 3) {
                    result = result.concat(vertical);
                }
                vertical = [];
                vertical.push(piece);
            }

            pieceBefore = piece;
        }
        if (vertical.length >= 3) {
            result = result.concat(vertical);
        }

        return result;
    }

    // private changeScore(clustersLength: number): void {
    //     this.score = this.score + (clustersLength * LevelObject.scoreCounter);
    //     FillBarService.changeBarFill(this.score, );
    //     this.score = 0;
    // }

    private onMouseMove(e) {
        if (this.drag && LevelObject.selectedTile.selected) {

            var pos = this.getMousePos(this, e);
            // Reset dragging
            let mt = this.getMouseTile(pos);
            if (mt.valid) {
                let tile;
                const tiles = LevelObject.tiles;
                for (let i = 0; i < tiles.length; i++) {
                    const tl = tiles[i][mt.x][mt.y];
                    if (tl.alpha === 1) {
                        tile = tl;
                    }
                }
                if (tile && this.canSwap(mt.x, mt.y, LevelObject.selectedTile.column, LevelObject.selectedTile.row)
                    && tile.alpha !== 0 && tile.type !== 0) {
                    this.interactive = false;
                    // Tiles can be swapped, swap the tiles
                    this.swapTiles(mt.x, mt.y, LevelObject.selectedTile.column,
                        LevelObject.selectedTile.row, LevelObject.selectedTile.map, tile.mapNum);
                }
            }
        }
    }

    public shuffle(): void {
        ShuffleService.shuffle(this.getConcatedMatrix(), this);
    }

    private onMouseDown(e) {
        this.scaleMoves(false)
        this.drag = false;
        // Get the mouse position
        const pos = this.getMousePos(this, e);
        // Start dragging
        if (!this.drag) {
            // Get the tile under the mouse
            let mt = this.getMouseTile(pos);

            let tile;
            const tiles = LevelObject.tiles;
            for (let i = 0; i < tiles.length; i++) {
                const tl = tiles[i][mt.x][mt.y];
                if (tl.alpha === 1) {
                    tile = tl;
                }
            }

            if (tile && mt.valid && tile.type !== 0 && tile.alpha !== 0) {
                // Valid tile
                tile.scale.set(0.53);
                LevelObject.selectedTile.map = tile.mapNum;
                LevelObject.selectedTile.column = mt.x;
                LevelObject.selectedTile.row = mt.y;
                LevelObject.selectedTile.tile = tile;
                LevelObject.selectedTile.selected = true;
            } else {
                // Invalid tile
                LevelObject.selectedTile.selected = false;
            }
            this.drag = true;
        }
    }

    protected onMouseUp(e) {
        var pos = this.getMousePos(this, e);
        // Reset dragging
        let mt = this.getMouseTile(pos);
        if (mt.valid) {
            let tile;
            const tiles = LevelObject.tiles;
            for (let i = 0; i < tiles.length; i++) {
                const tl = tiles[i][mt.x][mt.y];
                if (tl.alpha === 1) {
                    tile = tl;
                }
            }
            // if (tile && this.canSwap(mt.x, mt.y, LevelObject.selectedTile.column, LevelObject.selectedTile.row)
            //     && tile.alpha !== 0 && tile.type !== 0) {
            //     // Tiles can be swapped, swap the tiles
            //     this.swapTiles(mt.x, mt.y, LevelObject.selectedTile.column,
            //         LevelObject.selectedTile.row, LevelObject.selectedTile.map, tile.mapNum);
            // }
        }
        if (LevelObject.selectedTile.selected) {
            let selectedTile = LevelObject.tiles[LevelObject.selectedTile.map][LevelObject.selectedTile.column][LevelObject.selectedTile.row];
            selectedTile.scale.set(selectedTile.originScale.x, selectedTile.originScale.y);
            // selectedTile.alpha = 1;
            LevelObject.selectedTile = { selected: false, map: null, column: 0, row: 0, tile: null };

        }

        this.drag = false;
    }

    protected canSwap(x1, y1, x2, y2) {
        // Check if the tile is a direct neighbor of the selected tile
        if ((Math.abs(x1 - x2) === 1 && y1 === y2) ||
            (Math.abs(y1 - y2) === 1 && x1 === x2)) {
            return true;
        }

        return false;
    }

    protected getMousePos(canvas, e) {
        const rect = canvas.getBounds();
        return {
            x: Math.round((e.data.global.x - rect.left) / (rect.right - rect.left) * canvas.width),
            y: Math.round((e.data.global.y - rect.top) / (rect.bottom - rect.top) * canvas.height)
        };
    }

    protected async swapTiles(c1, r1, c2, r2, map2, map1) {
        // Save the current move
        // this.currentMove = {column1: c1, row1: r1, column2: c2, row2: r2};
        const currentMove = { column1: c1, row1: r1, column2: c2, row2: r2 };
        // Deselect
        let selectedTile = LevelObject.tiles[LevelObject.selectedTile.map][LevelObject.selectedTile.column][LevelObject.selectedTile.row];
        selectedTile.scale.set(selectedTile.originScale.x, selectedTile.originScale.y);
        // selectedTile.alpha = 1;
        LevelObject.selectedTile.map = null;
        LevelObject.selectedTile.column = null;
        LevelObject.selectedTile.row = null;
        LevelObject.selectedTile.selected = false;
        const coord1 = this.getCoordinateTile(currentMove.column1, currentMove.row1);
        const coord2 = this.getCoordinateTile(currentMove.column2, currentMove.row2);

        const tile1 = LevelObject.tiles[map1][c1][r1];
        const tile2 = LevelObject.tiles[map2][c2][r2];
        const newData = {
            tile1: {
                col: tile2.col,
                row: tile2.row,
                mapNum: tile2.mapNum
            },
            tile2: {
                col: tile1.col,
                row: tile1.row,
                mapNum: tile1.mapNum
            }
        }
        tile2.scale.set(tile2.originScale.x, tile2.originScale.y);

        gsap.to(tile1, .3, {
            x: coord2.tileX,
            y: coord2.tileY
        });

        gsap.to(tile2, .3, {
            x: coord1.tileX,
            y: coord1.tileY,
            onComplete: () => {
                LevelObject.tiles[map1][c1][r1].col = newData.tile1.col;
                LevelObject.tiles[map1][c2][r2].col = newData.tile2.col;
                LevelObject.tiles[map2][c1][r1].row = newData.tile1.row;
                LevelObject.tiles[map2][c2][r2].row = newData.tile2.row;
                LevelObject.tiles[map1][c1][r1].mapNum = newData.tile1.mapNum;
                LevelObject.tiles[map2][c2][r2].mapNum = newData.tile2.mapNum;
                [LevelObject.tiles[map1][c1][r1], LevelObject.tiles[map2][c2][r2]] = [LevelObject.tiles[map2][c2][r2], LevelObject.tiles[map1][c1][r1]];
                this.getAllChains(false, true, false, true).then(async (res) => {
                    if (res) {
                    } else {
                        LevelObject.tiles[map1][c1][r1].col = newData.tile1.col;
                        LevelObject.tiles[map1][c2][r2].col = newData.tile2.col;
                        LevelObject.tiles[map2][c1][r1].row = newData.tile1.row;
                        LevelObject.tiles[map2][c2][r2].row = newData.tile2.row;
                        LevelObject.tiles[map1][c1][r1].mapNum = newData.tile1.mapNum;
                        LevelObject.tiles[map2][c2][r2].mapNum = newData.tile2.mapNum;
                        [LevelObject.tiles[map1][c1][r1], LevelObject.tiles[map2][c2][r2]] = [LevelObject.tiles[map2][c2][r2], LevelObject.tiles[map1][c1][r1]];
                        gsap.to(tile1, .3, {
                            x: coord1.tileX,
                            y: coord1.tileY,
                        });

                        gsap.to(tile2, .3, {
                            x: coord2.tileX,
                            y: coord2.tileY,
                            onComplete: () => {
                                this.interactive = true;
                            }
                        });
                    }
                })
            }
        });
    }

    private addBackgroundImage(): void {
        const margin = LevelObject.tilesMargin;
        const blur = new PIXI.filters.BlurFilter();
        const bg_cut = new ReleaseBg(LoaderService.getResource(`${LevelsConfig.levels[this.level.num].image}_blur`).texture);
        bg_cut.width = this.width + margin * 2;
        bg_cut.height = this.height + margin * 2;
        bg_cut.name = 'bg_cut_release';
        bg_cut.zIndex = 20;

        const bg = new ReleaseBg(LoaderService.getResource(LevelsConfig.levels[this.level.num].image).texture);
        bg.width = this.width + margin * 2;
        bg.height = this.height + margin * 2;
        bg.name = 'bg_release'
        bg.zIndex = 20;
        bg.x = -32;
        bg.alpha = 0;

        const brush = new PIXI.Graphics();
        brush.beginFill(0xffffff);
        brush.drawRect(-margin / 2, -margin / 2, LevelObject.tileWidth, LevelObject.tileHeight);
        brush.endFill();
        const matrix = this.getConcatedMatrix();
        const maskTexture = PIXI.RenderTexture.create({
            width: bg_cut.width,
            height: bg_cut.height,
        });
        const mask = new PIXI.Sprite(maskTexture);
        this.addChild(mask);
        bg_cut.mask = mask;

        for (let i = 0; i < matrix.length; i++) {
            for (let j = 0; j < matrix[i].length; j++) {
                const tile = matrix[i][j];
                if (tile !== 0) {
                    brush.position.copyFrom(tile);
                    Main.instance.app.renderer.render(brush, maskTexture, false, null, false)
                }
            }
        }

        this.bgImage = bg;
        this.bgCutImage = bg_cut;
        this.addChild(bg_cut, bg)
    }

    protected getMouseTile(pos) {
        // Calculate the index of the tile
        const tx = Math.floor((pos.x) / (LevelObject.tileWidth));
        const ty = Math.floor((pos.y) / (LevelObject.tileHeight));
        // var tx = Math.floor((pos.x - LevelObject.x) / LevelObject.tileWidth);
        // var ty = Math.floor((pos.y - LevelObject.y) / LevelObject.tileHeight);

        // Check if the tile is valid
        const tiles = LevelObject.tiles;

        for (let d = 0; d < tiles.length; d++) {
            const map = tiles[d];
            for (let i = 0; i < map.length; i++) {
                for (let j = 0; j < map[i].length; j++) {
                    if (tx >= 0 && tx <= j && ty >= 0 && ty <= i) {
                        // Tile is valid
                        return {
                            valid: true,
                            map: i,
                            x: tx,
                            y: ty
                        };
                    }
                }
            }
        }

        // No valid tile
        return {
            valid: false,
            map: 0,
            x: 0,
            y: 0
        };
    }

    private changeScore(clustersLength: number, isAuto: boolean = true): void {
        if (!ScoreConfig.scoreTabl[clustersLength]) {
            return;
        }
        this.score = ScoreConfig.scoreTabl[clustersLength][isAuto ? 'auto' : 'simple'].score;
        const progress = ScoreConfig.scoreTabl[clustersLength][isAuto ? 'auto' : 'simple'].progress;
        FillBarService.changeScore(this.score, this.tilesOpen, this.needToOpen, this.level.num, this.timer);
        this.score = 0;
    }

    private createHelperTile(tile) {
        const block = new ReleaseBlock();
        const graphics = new PIXI.Graphics();
        block.zIndex = 100;
        graphics.beginFill(0x000000);
        graphics.drawRect(tile.x - LevelObject.tilesMargin / 2, tile.y - LevelObject.tilesMargin / 2,
            tile.width + LevelObject.tilesMargin, tile.height + LevelObject.tilesMargin);
        block.addChild(graphics);
        block.alpha = 0.6;
        block.isRelease = false
        block.isNeedToOpen = true;
        return block;
    }

    private sortContainerChildren(container): void {
        container.children.sort((a, b) => {
            return a.zIndex - b.zIndex;
        });
    }
}